export function plainTextExcerpt(value, maxLength = 120) {
  if (!value || typeof value !== 'string') {
    return '';
  }

  const text = value
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!text) {
    return '';
  }

  if (text.length <= maxLength) {
    return text;
  }

  return `${text.slice(0, maxLength).trim()}…`;
}
